<template>
    <b-row class="contenido">
        <b-col cols="12">
            <h3 data-cy="datos-pedido-heading">{{ $t('partido.completar_datos') }}</h3>
        </b-col>
        <b-col cols="12">
            <p>{{ $t('partido.completa_info') }}.</p>
        </b-col>
        <b-col cols="12">
            <ValidationObserver tag="form" ref="observer">
                <b-row>
                    <b-col sm="12" lg="6">
                        <div class="form-group">
                            <label>{{ $t('formularios.nombre') }}</label>
                            <ValidationProvider :name="$t('formularios.nombre')" rules="required" v-slot="{ errors }">
                                <input :disabled="desactivar" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.nombre')" v-model="datos_compradores.nombre" id="nombre" data-cy="datos-pedido-nombre"/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </b-col>
                    <b-col sm="12" lg="6">
                        <div class="form-group">
                            <label>{{ $t('formularios.apellidos') }}</label>
                            <ValidationProvider :name="$t('formularios.apellidos')" rules="required" v-slot="{ errors }">
                                <input :disabled="desactivar" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.apellidos')" v-model="datos_compradores.apellidos" id="apellidos" data-cy="datos-pedido-apellidos"/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </b-col>
                    <DateInput
                        v-model="datos_compradores.fecha_nacimiento"
                        id="fecha_nacimiento"
                        wrapperClass="col-12 col-lg-6"
                        dataCy="fecha-nacimiento"
                        :label="$t('formularios.nacimiento')"
                        :name="$t('formularios.nacimiento')"
                        :disabled="desactivar"
                    />
                    <b-col sm="12" lg="6">
                        <div class="form-group">
                            <label>{{ $t('formularios.telefono') }}</label>
                            <PhoneInput
                                :phone="datos_compradores.telefono ?? null"
                                :desactivar="desactivar"
                                :required="false"
                                :dataCy="'datos-pedido-telefono'"
                                @setNumber="(number) => datos_compradores.telefono = number"
                                @validNumber="(valid) => isValidNumber = valid"
                            />
                        </div>
                    </b-col> 
                    <b-col sm="12" lg="6">
                        <div class="form-group">
                            <label>{{ $t('formularios.cp') }}</label>
                            <ValidationProvider :name="$t('formularios.cp')" rules="required" v-slot="{ errors }">
                                <input
                                    type="text"
                                    :disabled="desactivar"
                                    :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                    :placeholder="$t('formularios.cp')"
                                    v-model="datos_compradores.cp"
                                    id="cp"
                                    data-cy="datos-pedido-cp"
                                />
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </b-col>
                    <b-col sm="12" lg="6">
                        <div class="form-group">
                            <label>{{ $t('formularios.dni') }}</label>
                            <ValidationProvider :name="$t('formularios.dni')" rules="required" v-slot="{ errors }">
                                <input :disabled="desactivar" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.dni')" v-model="datos_compradores.dni" id="dni" data-cy="datos-pedido-dni"/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </b-col>
                    <b-col sm="12" lg="6">
                        <div class="form-group">
                            <label>{{ $t('formularios.email') }}</label>
                            <ValidationProvider :name="$t('formularios.email')" rules="required|email" vid="confirmation" mode="passive" v-slot="{ errors }">
                                <input :disabled="desactivar" type="" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.email')" v-model="datos_compradores.email" id="email" data-cy="datos-pedido-email"/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </b-col>
                    <b-col sm="12" lg="6">
                        <div class="form-group">
                            <label>{{ $t('formularios.confirmar_email') }}</label>
                            <ValidationProvider :name="$t('formularios.confirmar_email')" :rules="'required|confirmed_ci:@confirmation'" mode="passive" v-slot="{ errors }">
                                <input :disabled="desactivar" type="" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.confirmar_email')" v-model="datos_compradores.email_confirmation" id="email_confirmation" data-cy="datos-pedido-email-confirmation"/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>                            
                        </div>
                    </b-col>
                </b-row>
                <template v-for="(evento, index) in entradas">
                    <b-row :key="index" v-if="evento.solicitar_datos">
                        <b-col cols="12">
                            <b-row v-for="(entrada, entradaIndex) in evento.items" :key="entradaIndex">
                                <b-col cols="12">
                                    <hr/>
                                </b-col>
                                <b-col cols="12">
                                    <div class="col-12 subtitle h3 light mb-3 mb-lg-3">
                                        {{ ++entradaIndex + ' - ' + (entrada.entrada.descripcion || entrada.entrada.description) }}
                                    </div>
                                </b-col>
                                <b-col cols="12">
                                    <b-col cols="12">
                                        <FormInput
                                            :disabled="desactivar"
                                            :label="$t('formularios.nombre')"
                                            :name="$t('formularios.nombre') + ' de la entrada ' + ++entradaIndex"
                                            rules="required"
                                            v-model="entrada.nombre"
                                            data-cy="datos-pedido-entrada-nombre"
                                        />
                                    </b-col>
                                    <b-col cols="12">
                                        <FormInput
                                            :disabled="desactivar"
                                            :label="$t('formularios.apellidos')"
                                            :name="$t('formularios.apellidos') + ' de la entrada ' + ++entradaIndex"
                                            rules="required"
                                            v-model="entrada.apellidos"
                                            data-cy="datos-pedido-entrada-apellidos"
                                        />
                                    </b-col>
                                    <b-col cols="12">
                                        <FormInput
                                            :disabled="desactivar"
                                            :label="$t('formularios.telefono')"
                                            :name="$t('formularios.telefono') + ' de la entrada ' + ++entradaIndex"
                                            rules="required"
                                            v-model="entrada.telefono"
                                            data-cy="datos-pedido-entrada-telefono"
                                        />
                                    </b-col>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </template>
                
            </ValidationObserver>
        </b-col>
        <b-col cols="12">
            <FormTerminos 
                @continuar="aceptarCondiciones"
                :desactivar="desactivar"
                :error="error"
                :carrito="true"
            />        
        </b-col>
    </b-row>
</template>

<script>
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import FormTerminos from '@/components/frontend/components/FormTerminos';
    import DateInput from "@/modules/ui/DateInput";

    export default {
        props: {
            entradas: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                datos_compradores: {},
                desactivar: false,
                terminos: false,
                error: false,
                entrada: {}
            }
        },
        computed: {
            datos_entradas() {
                let datos = [];

                this.entradas.forEach(evento => {
                    if(evento.solicitar_datos) {
                        evento.items.forEach(item => {
                            datos.push({
                                'id': item.id,
                                'datos_entrada': {
                                    'nombre': item.nombre,
                                    'apellidos': item.apellidos,
                                    'telefono': item.telefono
                                }
                            })
                        });
                    }
                });

                return datos;
            }
        },
        methods: {
            aceptarCondiciones(continuar, privacidad, condiciones, comunicaciones) {
                this.datos_compradores.privacidad = privacidad;
                this.datos_compradores.condiciones = condiciones;
                this.datos_compradores.comunicaciones = comunicaciones;
                this.terminos = continuar == true;
            },
            async terminar() {
                const isValid = await this.$refs.observer.validate();

                if (isValid && this.terminos) {
                    this.continuar();
                } else {
                    this.error = true;
                }
            },
            continuar() {
                this.$emit('continuar', this.datos_compradores, this.datos_entradas)
            }
        },
        components: {
            PhoneInput, FormTerminos, DateInput
        }
    }
</script>

<style scoped>
.contenido {
    background-color: #EDEDED;
    padding: 30px 50px;
    margin-bottom: 50px;
}

@media (max-width: 768px) {
    .contenido {
        padding: 10px
    }
}
</style>